import React, { useState, useEffect, useRef } from 'react'
import ROUTES from '../../../../../server/config'
import { get_messages, send_message } from '../../../../../server/requests'
import axios from 'axios'
import './Chat.scss'
import InputPanel from './InputPanel'
import MessageBox from './MessageBox'

import { decrypt } from '../../../../Util/util'

export default function Chat({ adminReadAllMessages, setNotReadMessagesCount }) {

    const [chatList, setChatList] = useState([])
    const [showProgress, setShowProgress] = useState(false)
    const [progressInner, setProgressInner] = useState(0)
    const [showLoadingMessages, setShowLoadingMessages] = useState(false)

    const progressElem = useRef(null)

    useEffect(() => {
        setShowLoadingMessages(true)

        get_messages({ query: { "sort": ["id", "DESC"], page: 1, limit: 10000 } }, (res) => {

            setNotReadMessagesCount(0)

            res.rows = res.rows.reverse()

            const arr_messages = []

            res.rows.map(e => {

                let obj = {
                    id: e.id,
                    type: e.type,
                    value: e.content,
                    sender: e.sender,
                    time: e.createdAt,
                    conversation_id: e.conversation_id,
                    is_read: e.is_read
                }

                arr_messages.push(obj)

            })

            setChatList([...arr_messages])
            setShowLoadingMessages(false)


        }, (err) => {
            setShowLoadingMessages(false)
            console.log(err, 'err')
        }
        )

    }, [adminReadAllMessages])

    useEffect(() => {
        if (chatList.length) {
            let elems = document.getElementsByClassName('time_in_message')
            let lastElem = elems[elems.length - 1]
            // { block: "center", behavior: "smooth" }
            if (lastElem) lastElem.scrollIntoView({ behavior: 'auto', block: 'end' })
        }

    }, [chatList])

    const sendMessage = (message, file = '') => {

        let newArray = [...chatList]
        let obj = {
            id: Date.now(),
            value: message,
            sender: 'user',
            time: new Date().getTime(),
            is_read: false,
            content_type: 'file',
            my_file: true
        }
        let body = {}
        let _type = ''

        if (message.image) {
            obj.type = 'image'
            obj.value = message.image
            _type = 'image'
        } else if (message.video) {
            obj.type = 'video'
            obj.value = message.video
            _type = 'video'
        } else if (message.application) {
            obj.type = 'application'
            obj.value = message.application
            _type = 'application'
        } else {
            obj.type = 'text'
            obj.value = message
            obj.content_type = 'message'

        }

        if (file) {
            console.log(file)
            // formdata
            body = new FormData()
            body.append('content', file)
            body.append('type', _type)

        } else {
            body.content = message
        }

        if (obj.type == 'text' && !obj.value.trim().length) return

        if (obj.type == 'text') {
            console.log('asdasdas')

            send_message(obj.content_type, body, (res) => {
                console.log(res, 'send message')
                newArray.push(obj)
                setChatList([...newArray])
            })
        } else {
            newArray.push(obj)
            setProgressInner(0)

            setShowProgress(true)
            setChatList([...newArray])
            const headers = { 'Content-Type': 'multipart/form-data' };
            const data = body;

            let url = ROUTES.send_message(obj.content_type) + '?token=' + decrypt('token',localStorage.getItem("token"));

            if (localStorage.getItem("token")) data.token = decrypt('token', localStorage.getItem("token"));

            let config = {
                method: "POST",
                url: url,
                onUploadProgress: progressEvent => {
                    let percent = (progressEvent.loaded / progressEvent.total) * 100
                    if (progressElem && progressElem.current) progressElem.current.style.backgroundImage = `conic-gradient(green ${360 / 100 * percent}deg, rgba(255, 255, 255, 0.5) ${360 / 100 * percent}deg)`
                    setProgressInner(Math.round(percent))
                },
                headers: headers
            }

            config.data = data

            axios(config)
                .then(({ data }) => {
                    setShowProgress(false)
                })
                .catch(({ message }) => {

                    setShowProgress(false)

                });
        }



    }

    return (
        <div className="main_chat">
            <MessageBox
                showLoadingMessages={showLoadingMessages}
                list={chatList} progressElem={progressElem}
                showProgress={showProgress}
                progressInner={progressInner}
            />
            <InputPanel
                sendMessage={sendMessage}
            />
        </div>
    )

}